export default __webpack_public_path__ + "static/media/contact-info.cf367751.svg";